export default __webpack_public_path__ + "static/media/ftmacreszlp.f1a74225.png";